import * as React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';

import styles from './SideFiltersFormHeader.module.css';

export interface SideFiltersFormHeaderProps {
  sideFiltersCount: number;
  toggleSideFiltersForm: () => void;
}

export const SideFiltersFormHeader = ({
  sideFiltersCount,
  toggleSideFiltersForm,
}: SideFiltersFormHeaderProps) => {
  const { T } = useIntl();

  return (
    <div className={styles.root}>
      <div className={styles.filterCount}>
        <Typography variant="h3">{T('search_page.filters.filters')}</Typography>
        <div className={styles.circleOutlined}>{sideFiltersCount}</div>
      </div>
      <IconButton
        className={styles.closeFilters}
        onClick={toggleSideFiltersForm}
      >
        <CloseIcon color="secondary" />
      </IconButton>
    </div>
  );
};
